import Content from 'mythulu-core/layouts/Content';

const Forbidden = () => (
  <Content>
    <p>You do not have permission to access this resource.</p>
  </Content>
);

export default Forbidden;
